import axios from "axios";
import { API_BASE_PKIX_URL } from "../../../util/constants";

export function requestTrusts() {
  return axios.request({
    method: "get",
    withCredentials: true,
    url: API_BASE_PKIX_URL + "/trusts",
  });
}

export function requestUploadCert(params: any) {
  const formData = new FormData();
  formData.append("caCertFile", params);

  return axios.request({
    method: "POST",
    url: API_BASE_PKIX_URL + "/add-ca",
    withCredentials: true,
    data: formData,
  });
}

export function requestDownloadCert(params: any) {
  return axios.request({
    method: "get",
    withCredentials: true,
    url: API_BASE_PKIX_URL + "/download-ca",
    responseType: "blob",
    params: {
      thumbPrint: params,
    },
  });
}
